module.exports = __webpack_public_path__ + "img/p3-p2-diaoxiang.071a5d48.png";